import React, { createContext, useContext, useReducer, useState } from "react";

export const modalContext = createContext();

export const initialState = {
    title: "",
    children: "",
    onRequestClose: (next) => {
        next();
    },
    confirmText: "Okay",
    variant: null,
    cancelButtonRef: null,
    disabled: false,
};

export function reducer(state, action) {
    return Object.assign({}, state, action);
}

export function ProvideModal({ children }) {
    const modal = useProvideModal();
    return (
        <modalContext.Provider value={modal}>{children}</modalContext.Provider>
    );
}

export const useModal = () => {
    return useContext(modalContext);
};

function useProvideModal() {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [open, setOpen] = useState(false);

    return {
        state,
        set: dispatch,
        open,
        setOpen,
        show: (newState = initialState) => {
            dispatch(Object.assign({}, initialState, newState));
            setOpen(true);
        },
    };
}
